"use strict";

exports.__esModule = true;
exports.GridFields = GridFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for GridElement.
 */
function GridFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("Grid.rows.label", "Rows")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 3,
      max: 48,
      value: element.props.rowCount || 12,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "rowCount", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("Grid.columns.label", "Columns")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 3,
      max: 48,
      value: element.props.columnCount || 12,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "columnCount", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("Grid.padding.label", "Padding"),
      helperText: translate("Grid.padding.helperText", "The padding around the element.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 64,
      value: element.props.padding || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "padding", value);
      }
    })));
  });
}